<template>
    <div class="alert-card alert-danger" v-if="errorMessages && errorMessages.length > 0">
        <ul class="list-group list-group-flush" v-for="error in errorMessages" :key="error">
            <li class="list-group-item text-danger">{{error}}</li>
        </ul>
    </div>
</template>
<script>
    export default {
        name: 'ErrorMessages',
        props: ['errorMessages']
    }
</script>
<style scoped type="scss">
    .alert-card {
        margin: 1.25rem -1.25rem;
        padding: 1.25rem;
    }
</style>